<template>
  <div>
    <transition name="fade" appear>
      <MaterialView
        v-if="isMaterialOpened"
        @close-material="closeMaterial"
        :src="iframeSrc"
        :isLoading="isMaterialsAuthCheckLoading"
      />
    </transition>
    <div v-if="!isMaterialOpened" class="materials">
      <img class="materials__logo-mobile" src="@/assets/images/brand/logo.svg" />
      <img class="materials__logo-desktop" src="@/assets/images/brand/logo_full.svg" />
      <div class="materials__container">
        <template>
          <div class="materials__content">
            <div class="flex items-center">
              <h3 class="materials__title">
                {{ $t("dashboard.maretials_online_list") }}
              </h3>
            </div>
          </div>
          <MaterialList :materials="getUserMaterials" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState, mapMutations, mapGetters, mapActions,
} from 'vuex';
import * as Sentry from '@sentry/vue';

import MaterialList from '@/components/MaterialList/MaterialList.vue';
import MaterialView from '@/components/MaterialView/MaterialView.vue';
import doEncrypt from '../../helpers/encrypt';

class EmptyMaterialListError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'Pusta lista materiałów online';
  }
}
// class LoadingMaterialError extends Error {
//   constructor(message = '') {
//     super(message);
//     this.name = 'Błąd wczytywania materiału online';
//   }
// }

export default {
  name: 'OnlineMaterials',
  components: {
    MaterialList,
    MaterialView,
  },

  data() {
    return {
      isMaterialOpened: false,
      windowWidth: 0,
      isLoading: true,
      iframeSrc: null,
      isMaterialsAuthCheckLoading: false,
    };
  },

  computed: {
    ...mapState('students', ['student']),
    ...mapState('auth', ['user', 'currentProfile', 'isOfficeLogin']),
    ...mapState('materials', ['realizations']),
    ...mapGetters('materials', ['getMasterUpdateIndex', 'getUserMaterials', 'getAllMaterials']),
    ...mapGetters('auth', [
      'isFullAccess',
      'isAgentProfile',
      'isAdditionalAccessProfile',
      'isParentProfile',
      'getToken',
      'getAgentData',
      'getAdditionalAccessData',
    ]),
    ...mapGetters('students', ['getStudent']),
  },

  methods: {
    ...mapMutations('layout', ['showClassList', 'hideClassList']),
    ...mapActions('students', ['updateStudent']),
    ...mapActions('lessons', ['clearLesson', 'clearLessons']),
    ...mapActions('homeworks', ['clearHomeworks']),
    ...mapActions('materials', [
      'setMasterUpdateIndex',
      'loadAllMaterials',
      'verifyMaterialsAuthorization',
    ]),
    setOnlineToken() {
      if (this.getToken) {
        let data = {};
        if (this.isAgentProfile) {
          data = {
            authToken: this.getToken,
            lectorId: this.getAgentData.id,
            profileType: 'agent',
          };
        } else if (this.isAdditionalAccessProfile) {
          data = {
            authToken: this.getToken,
            lectorId: this.getAdditionalAccessData.id,
            profileType: 'additionalAccess',
          };
        } else if (this.isParentProfile) {
          data = {
            authToken: this.getToken,
            studentId: this.getStudent.id,
            profileType: 'student',
          };
        }
        const encryptedAuthToken = doEncrypt(JSON.stringify(data));
        const date = new Date();
        date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
        const expires = date.toUTCString();
        document.cookie = `auth-funpark=${encryptedAuthToken}; path=/; domain=.earlystage.pl; expires=${expires};`;
      }
    },
    emptyMaterialListException({ isInitialAttempt }) {
      Sentry.withScope((scope) => {
        const attempt = isInitialAttempt ? 'initial' : 'retry';
        scope.setTag('attempt', attempt);

        let realizationsIds = 'undefined'; // yes - string saying 'undefined'
        if (this.realizations) {
          realizationsIds = this.realizations.map(item => item.id).join();
        }
        realizationsIds = realizationsIds === '' ? 'empty' : realizationsIds;
        scope.setTag('realizations ID', realizationsIds);

        let allMaterialsIds = 'undefined'; // yes - string saying 'undefined'
        if (this.getAllMaterials) {
          allMaterialsIds = this.getAllMaterials.map(item => item.id).join();
        }
        allMaterialsIds = allMaterialsIds === '' ? 'empty' : allMaterialsIds;
        scope.setTag('all materials ID', allMaterialsIds);

        const userId = this.user?.id || 'undefined';
        scope.setTag('user ID', userId);

        const studentId = this.getStudent?.id || 'undefined';
        scope.setTag('student ID', studentId);

        const userRole = this.currentProfile;
        scope.setTag('user ROLE', userRole);

        const loginSource = this.isOfficeLogin ? 'office' : 'direct';
        scope.setTag('login SOURCE', loginSource);

        scope.setLevel('info');
        Sentry.captureException(new EmptyMaterialListError(`User ID: ${userId}`));
      });
    },
    errorLoadingMaterialException() {
      // Sentry.withScope((scope) => {
      //   const userId = this.user?.id || 'undefined';
      //   scope.setTag('user ID', userId);

      //   const studentId = this.getStudent?.id || 'undefined';
      //   scope.setTag('student ID', studentId);

      //   const userRole = this.currentProfile;
      //   scope.setTag('user ROLE', userRole);

      //   const loginSource = this.isOfficeLogin ? 'office' : 'direct';
      //   scope.setTag('login SOURCE', loginSource);

      //   const currentMaterialId = materialId || 'undefined';
      //   scope.setTag('material ID', currentMaterialId);

      //   let errors = 'undefined';
      //   if (errorCodes) {
      //     errors = errorCodes.map(item => item).join();
      //   }
      //   errors = errors === '' ? 'empty' : errors;
      //   scope.setTag('errors', errors);

      //   scope.setLevel('info');
      //   Sentry.captureException(new LoadingMaterialError(`User ID: ${userId} / Material ID: ${currentMaterialId}`));
      // });
    },

    clearOnlineToken() {
      document.cookie = 'auth-funpark=; Max-Age=0; path=/; domain=.earlystage.pl';
    },
    async openMaterial({ iframeSrc, materialId }) {
      this.setOnlineToken();
      this.iframeSrc = iframeSrc;
      this.isMaterialOpened = true;
      this.isMaterialsAuthCheckLoading = true;

      try {
        const { success, data } = await this.verifyMaterialsAuthorization();
        if (!success) {
          this.errorLoadingMaterialException({ errorCodes: data, materialId });
        }
      } catch {
        this.errorLoadingMaterialException({ errorCodes: ['NETWORK'], materialId });
      }

      this.isMaterialsAuthCheckLoading = false;
      document.body.classList.add('iframe-on');
    },
    closeMaterial() {
      this.isMaterialsAuthCheckLoading = false;
      this.isMaterialOpened = false;
      this.iframeSrc = null;
      this.clearOnlineToken();
      document.body.classList.remove('iframe-on');
    },
  },

  mounted() {
    this.$root.$on('open-material', this.openMaterial);
    document.body.classList.add('hide-class-list');

    if (this.getUserMaterials && this.getUserMaterials.length) {
      this.isLoading = false;
    }
  },
  watch: {
    $route() {
      this.isMaterialOpened = false;
      this.windowWidth = 0;
      this.isLoading = true;
      this.iframeSrc = null;
      this.isMaterialsAuthCheckLoading = false;
    },
  },
  destroyed() {
    document.body.classList.remove('hide-class-list');
    document.body.classList.remove('iframe-on');
    this.clearOnlineToken();
  },
  beforeDestroy() {
    this.$root.$off('open-material', this.openMaterial);
    this.$root.$emit('handle-logout-highlight', false);
  },

  async created() {
    // increment when major updates show up on all materials list - to avoid cache issues
    const MASTER_UPDATE_INDEX = 1;

    const isMaterialsMasterUpdate = this.getMasterUpdateIndex !== MASTER_UPDATE_INDEX;
    this.hideClassList();
    this.clearLesson();
    this.clearLessons();
    this.clearHomeworks();

    if (!this.isFullAccess) {
      if (isMaterialsMasterUpdate) {
        this.setMasterUpdateIndex({ index: MASTER_UPDATE_INDEX });
        await this.loadAllMaterials();
      }
      this.isLoading = false;
      return;
    }

    if (this.student?.id) {
      await this.updateStudent(this.student.id);
    }

    if (this.isFullAccess && (!this.getAllMaterials?.length || isMaterialsMasterUpdate)) {
      if (isMaterialsMasterUpdate) this.setMasterUpdateIndex({ index: MASTER_UPDATE_INDEX });
      await this.loadAllMaterials();
      if (!this.getUserMaterials || !this.getUserMaterials.length) {
        this.$root.$emit('handle-logout-highlight', true);
        this.emptyMaterialListException({ isInitialAttempt: false });
      }
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss">
.materials {
  width: 100%;
  overflow: hidden;

  .link {
    a {
      text-decoration: none;
    }
  }

  @apply min-h-full pb-32 relative;
  padding-top: 30px;
  z-index: 1;

  @media screen and (min-width: 992px) {
    margin-left: auto;
    width: calc(100% - 312px);
  }

  &__view-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    height: 500px;
  }

  &__close-view {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    -webkit-text-stroke-width: 0;
  }

  &__view {
    width: 100%;
    flex-grow: 1;
    background-color: #fff;

    iframe {
      width: 100%;
      height: 100%;
    }
  }

  &__container {
    @apply mx-auto w-full pt-8 px-4;
    padding-bottom: 30px;

    @media screen and (min-width: 992px) {
      @apply mx-0;
      padding-left: 78px;
      padding-right: 40px;
    }
  }

  &__content {
    margin-bottom: 20px;
    @apply flex flex-col items-start;

    @media screen and (min-width: 320px) {
      @apply flex-row justify-between mb-8 items-center;
    }

    .system_monitor {
      @apply text-xl pl-0 mt-2 font-light inline-block;

      @media screen and (min-width: 320px) {
        @apply mt-0;
      }

      @media screen and (min-width: 768px) {
        @apply pl-8;
      }

      a {
        transition: color 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

        &:hover {
          @apply text-grey-dark;
        }
      }
    }
  }

  &__logo-mobile {
    @apply w-14 h-14 mx-auto block;

    @media screen and (min-width: 992px) {
      @apply hidden;
    }
  }

  &__logo-desktop {
    @apply mt-4 block;

    @media screen and (max-width: 991px) {
      @apply hidden;
    }

    @media screen and (min-width: 991px) {
      transform: translateX(78px);
    }
  }

  &__title {
    @apply text-2xl font-semibold mb-0;

    @media screen and (min-width: 992px) {
      @apply text-4xl;
    }
  }

  &__register-info-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 50px;

    @media screen and (max-width: 992px) {
      margin-top: 20px;
    }
  }

  &__register-info-inner-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 10px;
  }

  &__register-info {
    @apply text-black;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  &__link-prefix {
    @apply text-black;
    font-size: 16px;
    line-height: 18px;
  }

  &__link {
    font-weight: bold;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
    text-decoration: none;
    color: #ec268f;
  }

  &__icon {
    width: 52px;
  }

  &__empty-list {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
  }

  &__empty-list-label {
    @apply text-black;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
  }

  &__log-out {
    font-weight: bold;
    color: #ec268f;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
